module.exports = __webpack_public_path__ + "img/presentacion-sargazo.dae18cae.jpg";